import { render } from "./FileViewer.vue?vue&type=template&id=685d8436&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=685d8436&scoped=true&lang=css"
import "./FileViewer.vue?vue&type=style&index=1&id=685d8436&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685d8436"]])

export default __exports__